import { LoadingProgressEventEmitter } from '../../gameClient/loadingHandler/loadingProgressEventEmitter';

type SetPreloaderProgressParams = {
    percents: number;
};

export class SetPreloaderProgressHandler {
    public handle(params: SetPreloaderProgressParams): void {
        LoadingProgressEventEmitter.fireClientLoadingProgressEvent(params.percents);
    }
}
